const comments = [
  {
    name: '漫迷小明',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20person%20with%20warm%20friendly%20expression%2C%20minimalist%20style%2C%20soft%20lighting%2C%20cream%20background&width=80&height=80&seq=avatar-comment-01&orientation=squarish',
    text: 'UU漫画真的太良心了！找了好多平台都要付费，这里居然全部免费。<strong>免费漫画全集</strong>资源超全，画质也很清晰，已经推荐给身边所有漫友了！',
    time: '3天前',
    like: 128,
  },
  {
    name: '夜雨声烦',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20portrait%20of%20a%20person%20with%20a%20gentle%20smile%2C%20minimalist%20design%2C%20soft%20warm%20light%2C%20cream%20background&width=80&height=80&seq=avatar-comment-02&orientation=squarish',
    text: '更新速度真的快！每周追的热门连载基本当天就能看到<strong>免费完整版漫画</strong>。阅读体验也流畅，不用等加载，比某些收费平台还好用。',
    time: '5天前',
    like: 96,
  },
  {
    name: '风之漫画',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20portrait%20of%20a%20person%20wearing%20glasses%2C%20minimalist%2C%20friendly%20look%2C%20soft%20warm%20lighting%2C%20cream%20background&width=80&height=80&seq=avatar-comment-03&orientation=squarish',
    text: '作为一个看了十几年漫画的老漫迷，UU漫画的<strong>免费漫画大全</strong>资源库让我惊喜。很多冷门经典都能找到，还能<strong>全集免费看</strong>，简直是宝藏平台！',
    time: '1周前',
    like: 203,
  },
  {
    name: '樱花落',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20portrait%20of%20a%20person%20with%20long%20hair%20smiling%2C%20minimalist%2C%20warm%20expression%2C%20soft%20lighting%2C%20cream%20background&width=80&height=80&seq=avatar-comment-04&orientation=squarish',
    text: '夜间模式太适合睡前看了！而且<strong>在线免费阅读</strong>不需要注册，打开就能看，特别方便。每天睡前都会刷几话，已经成为日常习惯了。',
    time: '1周前',
    like: 87,
  },
  {
    name: '龙之传人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20portrait%20of%20a%20cool%20looking%20person%2C%20minimalist%2C%20confident%20expression%2C%20soft%20warm%20lighting%2C%20cream%20background&width=80&height=80&seq=avatar-comment-05&orientation=squarish',
    text: 'UU漫画分类做得很清晰，热血、恋爱、奇幻分门别类，找漫画特别快。<strong>免费漫画资源</strong>比想象中丰富太多，基本上想看的都有，强烈安利！',
    time: '2周前',
    like: 156,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">漫友评价</h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">听听广大漫迷对UU漫画<strong>在线免费阅读</strong>的真实反馈</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-100 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1" dangerouslySetInnerHTML={{ __html: comment.text }}></p>
              <div className="flex items-center gap-2 mt-4 pt-4 border-t border-background-100">
                <i className="ri-thumb-up-line text-primary-500 text-sm"></i>
                <span className="text-xs text-foreground-400">{comment.like} 人觉得有用</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}